var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',[_c('div',{staticClass:"q-display-1"},[_vm._v("Ustawienia")]),_vm._v("\n\n    Bla bla bla\n")])}
var staticRenderFns = []

export { render, staticRenderFns }